// extracted by mini-css-extract-plugin
export var active = "_kk-2";
export var recordingDot = "_kk-1";
export var recordingIndicator = "_kk-0";